import React from 'react';

const AlertTriangle = ({ width, height, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.90811 2.64331C7.4027 1.78556 8.59738 1.78556 9.09197 2.64331L14.4833 11.9932C14.9925 12.8764 14.3811 14 13.3913 14H2.60873C1.61893 14 1.00756 12.8764 1.51681 11.9932L6.90811 2.64331ZM7.41622 6.21312C7.38775 5.85771 7.6573 5.55289 8.00004 5.55289C8.34278 5.55289 8.61233 5.85771 8.58386 6.21312L8.34483 9.19788C8.32988 9.38448 8.17998 9.528 8.00004 9.528C7.8201 9.528 7.6702 9.38448 7.65525 9.19788L7.41622 6.21312ZM7.36334 11.5156C7.36334 11.1497 7.6484 10.853 8.00004 10.853C8.35168 10.853 8.63674 11.1497 8.63674 11.5156C8.63674 11.8815 8.35168 12.1781 8.00004 12.1781C7.6484 12.1781 7.36334 11.8815 7.36334 11.5156Z"
        fill={color}
      />
      <path
        d="M7.41622 6.21312C7.38775 5.85771 7.6573 5.55289 8.00004 5.55289C8.34278 5.55289 8.61233 5.85771 8.58386 6.21312L8.34483 9.19788C8.32988 9.38448 8.17998 9.528 8.00004 9.528C7.8201 9.528 7.6702 9.38448 7.65525 9.19788L7.41622 6.21312Z"
        fill="white"
      />
      <path
        d="M8.00004 10.853C7.6484 10.853 7.36334 11.1497 7.36334 11.5156C7.36334 11.8815 7.6484 12.1781 8.00004 12.1781C8.35168 12.1781 8.63674 11.8815 8.63674 11.5156C8.63674 11.1497 8.35168 10.853 8.00004 10.853Z"
        fill="white"
      />
    </svg>
  );
};

export default AlertTriangle;
